import { request } from "./request"

export const boardsApi = {

  getFsRoot: (userId) => {
    return request('GET', `/api/3/users/${userId}/fs/root`)
  },

  getCurrentFolderData: (userId, nodeId) => {
    return request('GET', `/api/3/users/${userId}/fs/root/nodes/${nodeId}/`)
  },

  getAncestorsItems: (userId, node_id) => {
    return request('GET', `/api/3/users/${userId}/fs/root/nodes/${node_id}/ancestors`)
  },

  getSystemFields: async (userID: number, signal?: AbortSignal): Promise<any> => {
    return request('GET', `/api/2/users/${userID}/fields/system`, undefined, { signal })
  },

  updateSystemField: async (userID: number, fieldID: string, data: { options?: any[], title?: string, description?: string }, signal?: AbortSignal): Promise<any> => {
    return request('PATCH', `/api/2/users/${userID}/fields/system/${fieldID}/`, data, { signal })
  },

  getBoardFields: async (userID: number, nodeId: string, signal?: AbortSignal): Promise<any> => {
    return request('GET', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/fields`, undefined, { signal })
  },

  updateBoardFields: async (userID: number, nodeId: string, fieldID: string, data: any, signal?: AbortSignal): Promise<any> => {
    return request('PUT', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/fields/${fieldID}`, data, { signal })
  },

  deleteBoardFields: async (userID: number, nodeId: string, fieldID: string, signal?: AbortSignal): Promise<any> => {
    return request('DELETE', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/fields/${fieldID}`, { signal })
  },

  updateField: async (userID: number, fieldID: string, data: { options?: any[], title?: string, description?: string }, signal?: AbortSignal): Promise<any> => {
    return request('PATCH', `/api/2/users/${userID}/fields/custom/${fieldID}/`, data, { signal })
  },

  getBoardsPublicLink: async (userID: number, sharedId: string, data: any, signal?: AbortSignal): Promise<any> => {
    return request('GET', `/api/2/users/${userID}/shared_with_me/fs/${sharedId}/dam/boards`, data, { signal })
  },
}
